import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleLeftMedium"><Path d="M6.83398 12L15 18.8594V5.14062L6.83398 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
